import React, { createContext, useContext, useEffect, useMemo, useState, } from 'react';
import FragmentStateManager from '../FragmentStateManager';
import { FragmentState } from '../interfaces';
import FullScreenTargetStateLatencyBuilder from '../observers/FullScreenTargetStateLatencyBuilder';
import Debug from '../../../util/Debug';
export const FragmentStateManagerContext = createContext(undefined);
export const FragmentStateManagerProvider = ({ customObservers = [], startTime = Date.now(), tenantId, children, }) => {
    const [stateManager] = useState(() => {
        const manager = new FragmentStateManager(tenantId);
        const defaultObservers = [
            new FullScreenTargetStateLatencyBuilder(FragmentState.Interactive),
            new FullScreenTargetStateLatencyBuilder(FragmentState.Complete),
        ];
        defaultObservers.forEach((observer) => manager.subscribe(observer));
        customObservers.forEach((observer) => manager.subscribe(observer));
        manager.initialize(startTime);
        return manager;
    });
    useEffect(() => () => {
        stateManager.terminate();
        stateManager.clearAllSubscribers();
    }, []);
    return (React.createElement(FragmentStateManagerContext.Provider, { value: stateManager }, children));
};
export const useFragmentStateManager = () => {
    const fragmentStateManager = useContext(FragmentStateManagerContext);
    if (!fragmentStateManager) {
        Debug.error('No FragmentStateManagerContext available! '
            + 'useFragmentStateManager must be used in components within FragmentStateManagerProvider.');
    }
    return useMemo(() => ({
        notifyStateChange: fragmentStateManager === null || fragmentStateManager === void 0 ? void 0 : fragmentStateManager.notifyStateChange,
        tenantId: fragmentStateManager === null || fragmentStateManager === void 0 ? void 0 : fragmentStateManager.tenantId,
    }), [fragmentStateManager]);
};
FragmentStateManagerProvider.defaultProps = {
    startTime: undefined,
    customObservers: [],
    children: undefined,
};
//# sourceMappingURL=FragmentStateManagerProvider.js.map